import { render, staticRenderFns } from "./CreateButton.vue?vue&type=template&id=fd0de084&scoped=true"
import script from "./CreateButton.vue?vue&type=script&lang=js"
export * from "./CreateButton.vue?vue&type=script&lang=js"
import style0 from "./CreateButton.vue?vue&type=style&index=0&id=fd0de084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0de084",
  null
  
)

export default component.exports